// extracted by mini-css-extract-plugin
module.exports = {"ErrorBackground":"ErrorBackground_ErrorBackground__gyutC"};